var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import { Box } from "@mui/material";
import ImageUpload from "../ImageUpload";
import Dialog from "../Dialog";
import { useRef, useState } from "react";
import { getCroppedImage } from "../../../helpers";
// This is to demonstate how to make and center a % aspect crop
// which is a bit trickier so we use some helper functions.
function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    return centerCrop(makeAspectCrop({
        unit: "%",
        width: 90,
    }, aspect, mediaWidth, mediaHeight), mediaWidth, mediaHeight);
}
var ImageUploadAndCrop = function (_a) {
    var value = _a.value, callback = _a.callback, _b = _a.width, width = _b === void 0 ? 200 : _b, _c = _a.height, height = _c === void 0 ? 200 : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, controlled = _a.controlled, _e = _a.circularCrop, circularCrop = _e === void 0 ? false : _e, onCloseCallback = _a.onCloseCallback, whiteFill = _a.whiteFill, rest = __rest(_a, ["value", "callback", "width", "height", "disabled", "controlled", "circularCrop", "onCloseCallback", "whiteFill"]);
    var _f = __read(useState(undefined), 2), croppedImageUrl = _f[0], setCroppedImageUrl = _f[1];
    var aspect = width / height;
    var _g = __read(useState(false), 2), showDialog = _g[0], setShowDialog = _g[1];
    var _h = __read(useState(null), 2), src = _h[0], setSrc = _h[1];
    var imageRef = useRef(null);
    var _j = __read(useState(), 2), cropConfig = _j[0], setCropConfig = _j[1];
    var onImageUpload = function (href) {
        setSrc(href);
        if (href) {
            setShowDialog(true);
        }
    };
    /**
     * closes the dialog
     */
    var handleDialogClose = function () {
        setShowDialog(false);
        setCropConfig(undefined);
    };
    /**
     * Triggered when user chooses to close the dialog
     */
    var forceCloseDialog = function () {
        if (onCloseCallback) {
            onCloseCallback();
        }
        handleDialogClose();
    };
    // set crop dimensions centered baased on media width and height when image uploads
    var handleImageLoad = function (e) {
        var _a = e.currentTarget, mediaWidth = _a.width, mediaHeight = _a.height;
        setCropConfig(centerAspectCrop(mediaWidth, mediaHeight, aspect));
    };
    var makeClientCrop = function (cropConfig) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(cropConfig.width && cropConfig.height && imageRef)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCroppedImage(imageRef.current, cropConfig, width, height, whiteFill).then(function (croppedImage) {
                            var croppedImageUrl = URL.createObjectURL(croppedImage);
                            setCroppedImageUrl(croppedImageUrl);
                            handleDialogClose();
                            if (callback) {
                                callback({ imgFile: croppedImage, imgUrl: croppedImageUrl });
                            }
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var buttonActions = [
        {
            onClick: function () {
                if (cropConfig) {
                    makeClientCrop(cropConfig);
                }
            },
            label: "Crop",
        },
        {
            onClick: forceCloseDialog,
            label: "Cancel",
            variant: "secondary",
        },
    ];
    var content = (_jsx(Box, __assign({ "data-testid": "upload-and-crop-dialog", sx: {
            maxWidth: "".concat(Math.max(width, 464), "px"),
            image: { maxWidth: "100%" },
        } }, { children: src && (_jsx(ReactCrop, __assign({ crop: cropConfig, onChange: function (cropConfig) { return setCropConfig(cropConfig); }, onComplete: function (cropConfig) { return setCropConfig(cropConfig); }, circularCrop: circularCrop, aspect: aspect }, { children: _jsx("img", { src: src, alt: "upload image", crossOrigin: "anonymous", onLoad: handleImageLoad, ref: imageRef }) }))) })));
    return (_jsxs(_Fragment, { children: [_jsx(ImageUpload, __assign({ value: controlled ? value : croppedImageUrl, uploadCallback: onImageUpload, disabled: disabled, controlled: controlled, circularCrop: circularCrop }, rest)), _jsx(Dialog, { title: "Crop Image", ctaOrientation: "horizontal", open: showDialog, buttonActions: buttonActions, content: content, handleClose: forceCloseDialog })] }));
};
export default ImageUploadAndCrop;
